import ColumnType from './ColumnType';
import SortType from './SortType';
import { BlotterColumn } from './ColumnPortfolio';
import { SortComparator } from '@instinet-analytics/core-lib';
import { IndigoAppContextType } from 'app/AppContext';
import { EnumMap } from '@instinet-analytics/core-lib';
import { OrderColumn } from 'communication/types/order/Order';

/*  eslint-disable @typescript-eslint/no-explicit-any */
export default interface Column<Type extends ColumnType> {
    id: BlotterColumn;
    name: string;
    dataField: OrderColumn | '';
    width: number;
    tag?: string;
    desc?: string;
    colType: Type;
    textAlign: string;
    labelFunction?: (context: IndigoAppContextType, value: any) => string;
    defaultSortDesc: boolean;
    sortType?: SortType;
    editable: boolean;
    itemEditor?: undefined;
    isPercentage?: boolean;
    caseInsensitive: boolean;
    resizable: boolean;
    sortCompareFunction?: SortComparator<any>;
    sortable: boolean;
    visible: boolean;
    draggable: boolean;
    allowStrMatch: boolean;
    allowSetFilter: boolean;
    scaleFunction?: (value: any, exchangeRate: number) => number;
    colFmt?: (context: IndigoAppContextType, value: any) => string;
    enumMap?: EnumMap;
    /*
     * If TRUE QuickSearch will treat this column as a string, even if it is numeric
     */
    textualQuickSearch?: boolean;
}
/*  eslint-enable @typescript-eslint/no-explicit-any */

export function getBaseColumn<Type extends ColumnType>(
    colType: Type
): Partial<Column<Type>> {
    return {
        name: '',
        dataField: '',
        width: 0,
        tag: undefined,
        desc: undefined,
        colType: colType,
        textAlign: 'left',
        labelFunction: undefined,
        defaultSortDesc: false,
        sortType: undefined,
        editable: false,
        itemEditor: undefined,
        caseInsensitive: false,
        sortCompareFunction: undefined,
        sortable: true,
        visible: true,
        draggable: true,
        allowStrMatch: true,
        allowSetFilter: false,
        scaleFunction: undefined,
        colFmt: undefined,
        resizable: true,
    };
}
